import React, { memo, useCallback } from 'react';
import cl from 'classnames';
import includes from 'lodash/includes';

import {
  FetchItemsSort,
  FetchItemsSortItems,
  FetchItemsSortableField,
  GADataType
} from '../../../types';

import { PureButtonHelper } from '../../buttons/PureButtonHelper';

import { words } from '../../../locales/keys';

interface AscDescButtonsSortProps {
  ascValue: FetchItemsSortableField;
  descValue: FetchItemsSortableField;
  sort: FetchItemsSort;
  onSort: FetchItemsSortItems;
}

function AscDescButtonsSort({
  ascValue,
  dataGa,
  descValue,
  sort,
  onSort
}: AscDescButtonsSortProps & GADataType) {
  const ascActive = includes(sort, ascValue);
  const descActive = includes(sort, descValue);

  const handleAscClick = useCallback<() => void>(() => {
    onSort(ascActive ? [] : [ascValue]);
  }, [ascValue, ascActive, onSort]);

  const handleDescClick = useCallback<() => void>(() => {
    onSort(descActive ? [] : [descValue]);
  }, [descValue, descActive, onSort]);

  return (
    <div className="border-b dark:border-gray-700 pb-1 flex gap-1">
      <PureButtonHelper
        className={cl(
          'py-0.5 pl-1 pr-1 rounded-md flex-1 text-xs flex items-center justify-center leading-5',
          ascActive
            ? 'focus:ring-base hover:bg-blue-500/25 text-blue-600 dark:text-blue-400 bg-blue-500/20'
            : 'text-gray-500 focus:ring-base hover:text-gray-950 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 focus:ring-offset-0'
        )}
        dataGa={`${dataGa}-sort-az-button`}
        i18nText={words.sortAZ}
        onClick={handleAscClick}
      />

      <PureButtonHelper
        className={cl(
          'py-0.5 pl-1 pr-1 rounded-md flex-1 text-xs flex items-center justify-center leading-5',
          descActive
            ? 'focus:ring-base hover:bg-blue-500/25 text-blue-600 dark:text-blue-400 bg-blue-500/20'
            : 'text-gray-500 focus:ring-base hover:text-gray-950 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 focus:ring-offset-0'
        )}
        dataGa={`${dataGa}-sort-za-button`}
        i18nText={words.sortZA}
        onClick={handleDescClick}
      />
    </div>
  );
}

export default memo(AscDescButtonsSort);
